import React, { Component } from 'react';
import styles from './counter.module.scss';
import PropTypes from 'prop-types';

import { Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'


export default class Conter extends Component
{
    constructor(props)
    {
        super(props)
        
        this.state = {
            number: 0
        }
    }

    render()
    {
        return(
            <div className={styles.permissionsToGrantCounter}>
                {
                    (!this.props.disabledMin) ?
                        <Button
                            shape="text"
                            icon={ <MinusOutlined /> }
                            onClick={() => this.props.action(-1) }
                            className={styles.counterIcon}
                            size="large"
                        />
                        :
                        null
                }
                <span className={styles.permissionsToGrantCounterText}>
                    { this.props.number }
                </span>
                <img
                    height="24"
                    width="14"
                    className={styles.remoteIcon}
                    src={require('../../img/icons/remote_gray.svg').default}
                />
                {
                    (!this.props.disabledMax) ?
                        <Button
                            shape="text"
                            icon={ <PlusOutlined /> }
                            onClick={ () => this.props.action(1) }
                            className={styles.counterIcon}
                            size="large"
                        />
                        :
                        null
                }
            </div>
        );
    }
}

Conter.propTypes =
{
    number: PropTypes.number,
    disabled: PropTypes.bool,
    action: PropTypes.func
}

Conter.defaultProps =
{
    isLoading: false,
    disabled: false,
    action: () => {}
}
